<!-- Header de modal -->
<div class="header">
   <p class="text-white">Actualizar datos fiscales</p>
</div>

<form [formGroup]="fiscalDataForm">
   <div class="body">

      <!-- Tipo de persona -->
      <div>
         <label class="mnf-control-label fs-bold fs-13 pb-2">Tipo de contribuyente</label>
         <mat-form-field appearance="outline" class="mnf-select">
            <mat-select disableRipple formControlName="personType">
               <mat-option value="">Seleccionar</mat-option>
               <mat-option [value]="pt.value" *ngFor="let pt of personType" [title]="pt.value">
                  {{ pt.viewValue }}
               </mat-option>
            </mat-select>
         </mat-form-field>
      </div>

      <!-- Régimen fiscal -->
      <div>
         <label class="mnf-control-label fs-bold fs-13 pb-2">Régimen Fiscal</label>
         <mat-form-field appearance="outline" class="mnf-select">
            <mat-select disableRipple formControlName="fiscalRegime">
               <mat-option value="">Seleccionar</mat-option>
               <mat-option [value]="fr.value" *ngFor="let fr of fiscalRegimes" [title]="fr.value">
                  {{ fr.viewValue }}
               </mat-option>
            </mat-select>
         </mat-form-field>
      </div>

      <!-- RFC -->
      <!-- <div>
         <label class="mnf-control-label fs-bold fs-13 pb-2">RFC</label>
         <mnf-input-form flat="1" formControlName="rfc" placeholder="Ej: XAXX010101000"
            errMsg="Debe estar lleno éste campo" mask="AAAAAAAAAAAAA||AAAAAAAAAAAA">
         </mnf-input-form>
      </div> -->

      <!-- Uso de CFDI -->
      <div class="mb-2 col-12">
         <label class="mnf-control-label fs-bold fs-13 pb-2">Uso de CFDI</label>
         <mat-form-field appearance="outline" class="mnf-select">
            <mat-select disableRipple formControlName="cfdiUse">
               <mat-option [value]="null">Seleccionar</mat-option>
               <mat-option [value]="cu.value" *ngFor="let cu of cfdiUsages" [title]="cu.value">
                  {{ cu.viewValue }}
               </mat-option>
            </mat-select>
         </mat-form-field>
      </div>

      <!-- Código Postal -->
      <div>
         <label class="mnf-control-label fs-bold fs-13 pb-2">Código postal</label>
         <mnf-input-form flat="1" mask="00000" formControlName="zipCode" placeholder="Ej: 00000"
            errMsg="Debe estar lleno éste campo" [dropSpecialCharacters]="true">
         </mnf-input-form>
      </div>

      <!-- Boton de guardar información -->
      <div class="d-flex align-items-center">
         <div class="text-center mt-3">
            <button class="btn" type="button" mat-button="mat-button" [disabled]="fiscalDataForm.invalid"
               (click)="saveCFDIInfo()">
               Actualizar información fiscal
            </button>
         </div>
      </div>
   </div>
</form>
